<template>
  <div width="100%">
    <Breadcrumb :title="'FMV Statement Bulk Processing'"></Breadcrumb>
    <div class="form-row">
      <div class="form-group col-md-12">
        <!-- <button class="btn btn-primary" v-on:click="getPDF('.pdf-page1')" style="float:right;margin-left:10px;">Export to Pdf</button> -->
        <button class="btn btn-primary" style="float:right;" @click="gotoFMVFootnotes">
          <span class="fa fa-tag"></span>&nbsp; Tag Footnotes
        </button>
        <button class="btn btn-secondary mr-3" style="float:right;" @click="gotoFMVENTRY">
          <span class="k-icon k-i-undo"></span>&nbsp; Back to FMV Statement
        </button>
      </div>
    </div>
    <div class="input-group">
      <div class="form-group col-md-12">
        <label class="section-title">Select Bulk Processing Criteria:</label>
        <!-- {{criteriaData.Partner}} -->
      </div>
      <br />
      <div class="input-group">
        <div class="form-group col-md-12">
          <div class="multi-field col-md-3">
            <label style="display:block">Memo Group</label>
            <div id="kendo-select">
              <kendo-dropdownlist
                v-model="criteriaData.MemoGroup"
                :data-source="dropdownOptions.MemoGroup"
                :data-text-field="'Option'"
                :option-label="'Select Memo Group'"
                :data-value-field="'Option'"
                v-on:select="onMemoGroupChange($event)"
              ></kendo-dropdownlist>
            </div>
          </div>

          <div class="multi-field multi-field-left col-md-3">
            <label class="required-label" style="display:block">Partner</label>
            <div id="kendo-select">
              <BaseMultiSelectDropdown
                :dropdownOptions="dropdownOptions"
                :criteriaData="criteriaData"
              ></BaseMultiSelectDropdown>
            </div>
          </div>
          
          <div class="multi-field col-md-3">
            <label class="required-label" style="display:block">Tax Period</label>
            <div id="kendo-select">
              <kendo-dropdownlist
                v-model="criteriaData.TaxPeriod"
                :data-source="dropdownOptions.TaxPeriod"
                :data-text-field="'Option'"
                :option-label="'Select Tax Period'"
                :data-value-field="'Option'"
                v-on:select="onTaxPeriodChange($event)"
              ></kendo-dropdownlist>
            </div>
          </div>
          <div class="multi-field multi-field-right col-md-3">
            <label class="required-label" style="display:block">Prior Tax Period</label>
            <div id="kendo-select">
              <kendo-dropdownlist
                v-model="criteriaData.PriorTaxPeriod"
                :data-source="dropdownOptions.PriorTaxPeriod"
                :data-text-field="'Option'"
                :option-label="'Select Prior Tax Period'"
                :data-value-field="'Option'"
              ></kendo-dropdownlist>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="row" style="width: 100%">
        <div class="col text-center">
          <button class="btn btn-primary" style="margin:5px" @click="getReportData">
            <span class="k-icon k-i-file-pdf"></span> &nbsp;Run Bulk Processing
          </button>
          <button class="btn btn-primary" style="margin:5px; padding-left: 50%;" @click="generateBulkPDF">
            <span class="k-icon k-i-file-pdf"></span> &nbsp;Run Bulk Printing
          </button>
        </div>

      </div>    
    </div>
    <br />
    <BaseToolBar v-show="displayGrid" :config="ToolBarConfig" @buttonClicked="GridToolBarClick"></BaseToolBar>
    <BaseGrid
      v-show="displayGrid"
      :mode="'editform'"
      @StatementDownload="statementDownload"
      :config="GridConfig"
      :data="FMVBulkGridData"
      :colorizeColumn="true"
    ></BaseGrid>

    <div
      v-for="(outerItem) in FMVBulkPDFData"
      :key="outerItem.PartnerId"
      :id="outerItem.PartnerId"
      ref="pdfRef"
      class="pdf-page1 size-a4 well"
      style="display:none"
    >
      <div>
        <div class="row FMVbottomdoubleborder">
          <div class="col">
            <img src="@/assets/Images/Tishmanlogo.jpeg" class="FMVImgcentre" />
            <img />
          </div>
        </div>
        <div class="row FMVbottomdoubleborder">
          <div class="col">
            <p class="FMVParabold">CONFIDENTIAL MEMORANDUM</p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <br />
            <span class="FMVcolSpan FMVParatext">To:</span>
            <span class="FMVParatext">Unit Program Participants</span>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <br />
            <span class="FMVcolSpan FMVParatext">From:</span>
            <span class="FMVParatext">Joe Doran</span>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <br />
            <span class="FMVcolSpan FMVParatext">Re:</span>
            <span class="FMVParatext">Semi-Annual Unit & Direct Investment Valuations</span>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <br />
            <span class="FMVcolSpan FMVParatext">Date:</span>
            <span class="FMVParatext">{{ new Date()|formatDate}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <hr style="border-top:1px dotted #000;" />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p class="FMVParatext" style="white-space: pre-line;">{{(MemoStartingSummary)}}</p>
            <br />
          </div>
        </div>

        <div class="row">
          <div class="col">
            <p class="FMVParatext" v-if="MemoProgramCurrentValueTextArray.length>0">
              Summary explanations of notable changes in
              <b>Current Values</b>
              from your {{`${criteriaData.TaxPeriod}`}} statements are as follows:
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <ul
              class="FMVParatext"
              v-for="(memoProgramText) in MemoProgramCurrentValueTextArray"
              :key="memoProgramText.Id"
            >
              <li>{{memoProgramText.MemoText}}</li>
            </ul>
            <br />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p class="FMVParatext" v-if="MemoProgramPotentialValueTextArray.length>0">
              Summary explanations of notable changes in
              <b>Potential Values</b>
              from your {{`${criteriaData.TaxPeriod}`}} statements are as follows:
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <ul
              class="FMVParatext"
              v-for="(memoProgramText) in MemoProgramPotentialValueTextArray"
              :key="memoProgramText.Id"
            >
              <li>{{memoProgramText.MemoText}}</li>
            </ul>
            <br />
          </div>
        </div>

        <div class="row">
          <div class="col">
            <p class="FMVParatext" style="white-space: pre-line;">{{MemoEndingSummary}}</p>
            <!-- <p class="page-break"></p> -->
          </div>
        </div>
      </div>
      <div
        class="new-page"
        v-for="(innerItem) in outerItem.PartnerPDF_EUM_EPP_Data"
        :key="innerItem.Id"
      >
      <p class="page-break"></p>
        <div>
          <div style="float:left">
            Partner :
            <span style="font-weight:bold">{{outerItem.PartnerName.toUpperCase()}}</span>
          </div>
          <div
            style="float:right;margin-right:20px;margin-bottom:20px;font-weight:bold"
          >STRICTLY CONFIDENTIAL</div>
        </div>

        <div v-show="innerItem.Id == 1 && innerItem.EPPProgramTypeGridPdfData">
          <div class="potential" style="clear:both;font-weight:bold">
            Potential and Current value statement for Employee Investment Program
            <br />
            as of {{taxDateToFilter | formatDate}} 
          </div>
        </div>
        <div v-show="innerItem.Id == 0 && innerItem.EUMProgramTypeGridPdfData">
          <div class="potential" style="clear:both;font-weight:bold">
            Potential and Current value statement for Employee Unit Program
            <br />
            as of {{taxDateToFilter | formatDate}}
          </div>
        </div>
        <!-- Employee Equity Investment Program -->
        <table class="pdf-table" id="pdf-template">
          <thead>
            <tr v-show="innerItem.Id == 1 && innerItem.EPPProgramTypeGridPdfData">
              <td style="width:220px !important"></td>
              <!-- border fix -->
              <!--  <td></td> -->
              <td colspan="3" class="fullborder">Commitments</td>
              <!-- <td></td> -->
              <td>[A]</td>
              <td>[B]</td>
              <td>[C=A+B]</td>
              <td></td>
              <td>[D]</td>
              <td>[E=A+D]</td>
              <td></td>
            </tr>
            <tr v-show="innerItem.Id == 0 && innerItem.EUMProgramTypeGridPdfData">
              <td style="width:220px !important"></td>
              <td></td>
              <td></td>
              <td>[A]</td>
              <td>[B]</td>
              <td>[C=A+B]</td>
              <td></td>
              <td>[D]</td>
              <td>[E=A+D]</td>
              <td></td>
              <td></td>
            </tr>
            <tr class="EUM" v-show="innerItem.Id == 0 && innerItem.EUMProgramTypeGridPdfData">
              <th style="border:none;width:220px !important" attr="Investment"></th>
              <!-- <th class="th-head" attr="InvestmentID" style="border-bottom:none">Investment ID</th> -->
              <!-- border fix -->
              <th class="th-top-EPP" attr="Units" style="border-left:1px solid">Units</th>
              <th
                class="th-top-EPP"
                attr="VestedPercent"
                style="border-bottom:none;border-right:1px solid;"
              >Vesting <br>Percentage<br></th>
              <th
                class="th-top-EPP"
                attr="PreviousUnitDistribution"
                style="border-bottom:none;border-right:1px solid;"
              >Previous Unit <br>Distributions<br></th>
              <th
                class="th-top-EPP"
                attr="ProjectedUnrealizedValue"
                style="border-bottom:none"
              >Projected <br> Unrealized Value <br>(Undiscounted)<br></th>
              <th
                class="th-top-EPP"
                attr="TotalPotentialPreTaxValue"
                style="border-bottom:none"
              >Total <br>Potential <br>Pre-Tax <br>Value<br></th>
              <th
                class="th-top-EPP"
                attr="TotalPotentialPreTaxValuePercentChange"
                style="border-right:1px solid"
              >Total <br>Potential <br>Pre-Tax <br>Value <br>Percentage <br>Change<br> Since <br>Prior <br>Statement<br></th>
              <th
                class="th-top-EPP"
                attr="CurrentValue"
                style="border-bottom:none"
              >Current Values <br>(Discounted)<br></th>
              <th
                class="th-top-EPP"
                attr="TotalCurrentPreTaxValue"
                style="border-bottom:none"
              >Total <br>Current <br>Pre-<br>Tax Value<br></th>
              <th
                class="th-top-EPP"
                attr="TotalCurrentPreTaxValuePercentChange"
                style="border-right:1px solid"
              >Total Current <br>Pre-Tax Value <br>Percentage <br>Change Since <br>Prior <br>Statement <br></th>
            </tr>
            <tr class="EPP" v-show="innerItem.Id == 1 && innerItem.EPPProgramTypeGridPdfData">
              <th style="border:none;width:220px !important" attr="Investment"></th>
              <th class="th-top-EPP" attr="CommitmentFunded" style="border-left:1px solid">Funded<br></th>
              <th class="th-top-EPP" attr="CommitmentRemaining" style="border-bottom:none">Remaining<br></th>
              <th
                class="th-top-EPP"
                attr="CommitmentTotal"
                style="border-bottom:none;border-right:1px solid"
              >Total<br></th>
              <th
                class="th-top-EPP"
                attr="PreviousUnitDistribution"
                style="border-bottom:none;border-right:1px solid"
              >Previous <br>Cash <br>Distributions<br></th>
              <th
                class="th-top-EPP"
                attr="ProjectedUnrealizedValue"
                style="border-bottom:none"
              >Projected <br>Remaining <br>Distributions<br></th>
              <th
                class="th-top-EPP"
                attr="TotalPotentialPreTaxValue"
                style="border-bottom:none"
              >Total <br>Projected <br>Pre-Tax Value <br>(Undiscounted)<br></th>
              <th
                class="th-top-EPP"
                attr="TotalPotentialPreTaxValuePercentChange"
                style="border-right:1px solid"
              >Total <br>Potential <br>Pre-Tax <br>Value <br>Percentage <br>Change <br>Since Prior <br>Statement<br></th>
              <th
                class="th-top-EPP"
                attr="CurrentValue"
                style="border-bottom:none"
              >Current <br>Values <br></th>
              <th
                class="th-top-EPP"
                attr="TotalCurrentPreTaxValue"
                style="border-bottom:none"
              >Total <br>Current<br> Pre-Tax <br>Value<br></th>
              <th
                class="th-top-EPP"
                attr="TotalCurrentPreTaxValuePercentChange"
                style="border-right:1px solid"
              >Total <br>Current <br>Pre-Tax <br>Value <br>Percentage <br>Change <br>Since Prior <br>Statement<br></th>
            </tr>
          </thead>
          <tbody v-for="(item) in innerItem.EPPProgramTypeGridPdfData" :key="item.Id">
            <tr v-if="item.IndexGroup == 0" class="investmentGrp-tr">
              <!-- border fix -->
              <td
                class="text_left"
                style="white-space: nowrap;font-weight:bold;padding-top:1.2%; text-decoration: underline;"
                v-html="item.InvestmentGroup.InvestmentGroup"
              ></td>
              <!-- <td colspan="10" style="border-right:1px solid"></td> -->
              <!-- border fix -->
              <td colspan="3" style="border-left:1px solid" class="border_right">&nbsp;</td>
              <td class="border_right">&nbsp;</td>
              <td colspan="3" class="border_right">&nbsp;</td>
              <td colspan="3" class="border_right">&nbsp;</td>
              <!-- border fix -->
            </tr>
            <tr v-if="item.IndexGroup != 0 && item.IndexGroup != 1" class="investment-tr">
              <!-- border fix -->
              <td class="text_left" style="white-space: normal !important;text-transform: uppercase;word-break: normal !important;
            word-wrap: break-word !important" v-html="item.Investment"></td>
              <td class="text_right" style="border-left:1px solid">{{item.CommitmentFunded | formatDecical}}</td>
              <td>{{item.CommitmentRemaining | formatDecical}}</td>

              <td class="text_right" style="border-right:1px solid">{{item.CommitmentTotal | formatDecical}}</td>

              <td class="text_right"
                style="border-right:1px solid"
              >{{item.HideNumberOnFMVS.indexOf("PreviousUnitDistribution") >= 0 ? "-" : item.PreviousUnitDistribution | formatDecical}}</td>
              <!-- <td class="text_right">{{item.HideNumberOnFMVS.indexOf("ProjectedUnrealizedValue") >= 0 ? "-" : item.ProjectedUnrealizedValue | formatDecical}}</td>
              <td class="text_right">{{item.HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValues") >= 0 ? "-" : item.TotalPotentialPreTaxValue | formatDecical}}</td> -->
              <td v-show="item.ProjectedUnrealizedValue!=null && !isNaN(item.ProjectedUnrealizedValue)" class="text_right">{{item.HideNumberOnFMVS.indexOf("ProjectedUnrealizedValue") >= 0 ? "-" : item.ProjectedUnrealizedValue | formatDecical}}</td>
              <td  v-show="item.ProjectedUnrealizedValue==null || isNaN(item.ProjectedUnrealizedValue)"  class="text_right">
                {{item.HideNumberOnFMVS.indexOf("ProjectedUnrealizedValue") >= 0 ? "-" : "N/A"}}</td>
              <td v-show="item.TotalPotentialPreTaxValue!=null && !isNaN(item.TotalPotentialPreTaxValue)" class="text_right">{{item.HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValues") >= 0 ? "-" : item.TotalPotentialPreTaxValue | formatDecical}}</td>
              <td  v-show="item.TotalPotentialPreTaxValue==null || isNaN(item.TotalPotentialPreTaxValue)"  class="text_right">
                {{item.HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValues") >= 0 ? "-" : "N/A"}}</td>
              <td 
                v-show="item.TotalPotentialPreTaxValuePercentChange!=null && !isNaN(item.TotalPotentialPreTaxValuePercentChange)"
                class="text_right"
                style="border-right:1px solid"
              >{{item.HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValuePercentChange") >= 0 ? "-" :
              ((parseFloat(item.TotalPotentialPreTaxValuePercentChange)*100).toFixed(2) == -0.00 ? "0.0" : (parseFloat(item.TotalPotentialPreTaxValuePercentChange)*100).toFixed(1) )  +"%"   }}</td>
              <td
                v-show="item.TotalPotentialPreTaxValuePercentChange==null || isNaN(item.TotalPotentialPreTaxValuePercentChange)"
                class="text_right"
                style="border-right:1px solid"
              >{{item.HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValuePercentChange") >= 0 ? "-" : "N/A"}}</td>

              <td class="text_right">{{item.HideNumberOnFMVS.indexOf("CurrentValue") >= 0 ? "-" :item.CurrentValue | formatDecical}}</td>
              <td class="text_right">{{item.HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValues") >= 0 ? "-" :item.TotalCurrentPreTaxValue | formatDecical}}</td>

              <td
                v-show="item.TotalCurrentPreTaxValuePercentChange!=null && !isNaN(item.TotalCurrentPreTaxValuePercentChange)"
                class="text_right"
                style="border-right:1px solid"
              >{{item.HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValuePercentChange") >= 0 ? "-" : 
              (parseFloat(item.TotalCurrentPreTaxValuePercentChange*100).toFixed(2) == -0.00 ? "0.0" : parseFloat(item.TotalCurrentPreTaxValuePercentChange*100).toFixed(1))+"%"}}</td>
              <td
                v-show="item.TotalCurrentPreTaxValuePercentChange==null || isNaN(item.TotalCurrentPreTaxValuePercentChange)"
                class="text_right"
                style="border-right:1px solid"
              >{{item.HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValuePercentChange") >= 0 ? "-" : "N/A"}}</td>
            </tr>
            <!-- border fix -->
            <!-- <br v-if="item.IndexGroup == 1" /> -->
            <tr v-if="item.IndexGroup == 1" class="total-class">
              <td class="text_left" style="font-weight:bold">TOTAL DIRECT INVESTMENT VALUE</td>
              <td class="text_right" style="border-left:1px solid">{{item.CommitmentFundedTotal | formatDecical}}</td>
              <td class="text_right">{{item.CommitmentRemainingTotal | formatDecical}}</td>
              <td style="border-right:1px solid">{{item.CommitmentValueTotal | formatDecical}}</td>
              <td class="text_right"
                style="border-right:1px solid"
              >{{item.PreviousUnitDistributionTotal | formatDecical}}</td>
              <td class="text_right">{{item.ProjectedUnrealizedValueTotal | formatDecical}}</td>
              <td class="text_right">{{item.TotalPotentialPreTaxValueTotal | formatDecical}}</td>
              <td style="border-right:1px solid"></td>
              <td class="text_right">{{item.CurrentValueTotal | formatDecical}}</td>
              <td class="text_right">{{item.TotalCurrentPreTaxValueTotal | formatDecical}}</td>
              <td style="border-right:1px solid"></td>
            </tr>
          </tbody>
          <tbody v-for="(item) in innerItem.EUMProgramTypeGridPdfData" :key="item.Id">
            <tr v-if="item.IndexGroup == 0" class="investmentGrp-tr">
              <!-- border fix -->
              <td
                style="white-space: nowrap;font-weight:bold; padding-top:1.2%"
                class="text_left"
                v-html="item.InvestmentGroup.InvestmentGroup"
              ></td>
              <!-- <td colspan="9" style="border-right:1px solid"></td> -->
              <!-- border fix -->
              <td colspan="2" style="border-left:1px solid" class="border_right">&nbsp;</td>
              <td class="border_right">&nbsp;</td>
              <td colspan="3" class="border_right">&nbsp;</td>
              <td colspan="3" class="border_right">&nbsp;</td>
              <!-- border fix -->
            </tr>
            <tr v-if="item.IndexGroup != 0 && item.IndexGroup != 1" class="investment-tr">
              <!-- border fix -->
              <td style="white-space: normal !important;text-transform: uppercase;word-break: normal !important;
            word-wrap: break-word !important" class="text_left" v-html="item.Investment"></td>
              <!-- <td style="border-right:1px solid">{{item.InvestmentID}}</td> -->
              <!-- border fix -->
              <!-- <td class="text_center" style="border-left:1px solid">{{parseFloat(item.Units).toFixed(2)}}</td>
              hot fix for -0.00 units -->
              <td class="text_center" style="border-left:1px solid">{{parseFloat(item.Units).toFixed(2) == -0.00 ? "0.00" : parseFloat(item.Units).toFixed(2)}}</td>
              <!-- border fix -->
              <td class="text_center"
                v-show="item.VestedPercent!=null && !isNaN(item.VestedPercent)"
                style="border-right:1px solid"
              >{{(parseFloat(item.VestedPercent)*100)}}%</td>
              <td class="text_center"
                v-show="item.VestedPercent==null || isNaN(item.VestedPercent)"
                style="border-right:1px solid"
              >N/A</td>

              <td class="text_right"
                style="border-right:1px solid"
                v-show="item.PreviousUnitDistribution!=null && !isNaN(item.PreviousUnitDistribution)"
              >{{item.HideNumberOnFMVS.indexOf("PreviousUnitDistribution") >= 0 ? "-" :item.PreviousUnitDistribution | formatDecical}}</td>

              <td class="text_right"
                style="border-right:1px solid"
                v-show="item.PreviousUnitDistribution==null || isNaN(item.PreviousUnitDistribution)"
              >{{"-"}}</td>


              <td class="text_right"
                v-show="item.ProjectedUnrealizedValue!=null && !isNaN(item.ProjectedUnrealizedValue)"
              >
              {{item.HideNumberOnFMVS.indexOf("ProjectedUnrealizedValue") >= 0 ? "-" :item.ProjectedUnrealizedValue | formatDecical}}</td>


              <td class="text_right"
                v-show="item.ProjectedUnrealizedValue==null || isNaN(item.ProjectedUnrealizedValue)"
              >
              {{"-"}}</td>


              <td class="text_right"
                v-show="item.TotalPotentialPreTaxValue!=null && !isNaN(item.TotalPotentialPreTaxValue)"
              >
              {{item.HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValue") >= 0 ? "-" :item.TotalPotentialPreTaxValue | formatDecical}}</td>


              <td class="text_right"
                v-show="item.TotalPotentialPreTaxValue==null || isNaN(item.TotalPotentialPreTaxValue)"
              >
              {{"-"}}</td>              
              <!-- 
              <td class="text_right">{{item.HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValues") >= 0 ? "-" :item.TotalPotentialPreTaxValue | formatDecical}}</td> -->


              <td class="text_right"
                v-show="item.TotalPotentialPreTaxValuePercentChange!=null && !isNaN(item.TotalPotentialPreTaxValuePercentChange)"
                style="border-right:1px solid"
              >{{item.HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValuePercentChange") >= 0 ? "-" :
              ((parseFloat(item.TotalPotentialPreTaxValuePercentChange)*100).toFixed(2) == -0.00 ? "0.0" : (parseFloat(item.TotalPotentialPreTaxValuePercentChange)*100).toFixed(1) )  +"%"   }}</td>
              <!-- Remove N/A and replaced with 0 -->
              <td
                v-show="item.TotalPotentialPreTaxValuePercentChange==null || isNaN(item.TotalPotentialPreTaxValuePercentChange)"
                class="text_right"
                style="border-right:1px solid; padd"
              >{{item.HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValuePercentChange") >= 0 ? "-" 
              : "N/A"}}</td>

              <!-- <td class="text_right">{{item.HideNumberOnFMVS.indexOf("CurrentValue") >= 0 ? "-" :item.CurrentValue | formatDecical}}</td> -->

              <td class="text_right"
                
                v-show="item.CurrentValue!=null && !isNaN(item.CurrentValue)"
              >{{item.HideNumberOnFMVS.indexOf("CurrentValue") >= 0 ? "-" :item.CurrentValue | formatDecical}}</td>

              <td class="text_right"
                v-show="item.CurrentValue==null || isNaN(item.CurrentValue)"
              >{{"-"}}</td>

              <td class="text_right"
                
                v-show="item.TotalCurrentPreTaxValue!=null && !isNaN(item.TotalCurrentPreTaxValue)"
              >{{item.HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValue") >= 0 ? "-" :item.TotalCurrentPreTaxValue | formatDecical}}</td>

              <td class="text_right"
               
                v-show="item.TotalCurrentPreTaxValue==null || isNaN(item.TotalCurrentPreTaxValue)"
              >{{"-"}}</td>


              <!-- <td class="text_right">{{item.HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValues") >= 0 ? "-" :item.TotalCurrentPreTaxValue | formatDecical}}</td> -->

              <td
                v-show="item.TotalCurrentPreTaxValuePercentChange!=null && !isNaN(item.TotalCurrentPreTaxValuePercentChange)"
                class="text_right"
                style="border-right:1px solid"
              >{{item.HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValuePercentChange") >= 0 ? "-" : 
              (parseFloat(item.TotalCurrentPreTaxValuePercentChange*100).toFixed(2) == -0.00 ? "0.0" : parseFloat(item.TotalCurrentPreTaxValuePercentChange*100).toFixed(1))+"%"}}</td>

              <td
                v-show="item.TotalCurrentPreTaxValuePercentChange==null || isNaN(item.TotalCurrentPreTaxValuePercentChange)"
                class="text_right"
                style="border-right:1px solid"
              >{{item.HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValuePercentChange") >= 0 ? "-" 
              :"N/A"}}</td>
            </tr>
            
            <!-- border fix -->
            <!-- <br v-if="item.IndexGroup == 1" /> -->
            <tr v-if="item.IndexGroup == 1" class="total-class">
              <td style="font-weight:bold" class="text_left">TOTAL UNIT VALUE</td>
              <!-- <td style="border-right:1px solid"></td> -->
              <td style="border-left:1px solid"></td>
              <td style="border-right:1px solid"></td>
              <td class="text_right"
                style="border-right:1px solid"
              >{{item.PreviousUnitDistributionTotal | formatDecical}}</td>
              <td class="text_right">{{item.ProjectedUnrealizedValueTotal | formatDecical}}</td>
              <td class="text_right">{{item.TotalPotentialPreTaxValueTotal | formatDecical}}</td>
              <td style="border-right:1px solid"></td>
              <td class="text_right">{{item.CurrentValueTotal | formatDecical}}</td>
              <td class="text_right">{{item.TotalCurrentPreTaxValueTotal | formatDecical}}</td>
              <td style="border-right:1px solid"></td>
            </tr>
          </tbody>
        </table>
        <br />
        <div class="row">
          <div v-if="innerItem.Id == 0" class="col">
        <table class="pdf-footnote2">
          <thead>
            <tbody v-for="note in EUMFootnotes" :key="note.InvestmentID">
            <tr >
              <td  style="text-align:left;vertical-align:top;padding:1;">{{"["+ note.TagNumber +"]" }}</td>
             <!-- <tr class="blank_row">
                <td colspan="2"></td>
              </tr> -->
              <td style="text-align:left;vertical-align:top;padding:1;">{{note.Footnote}} <br /></td>
              <td styple="padding:1;"></td>
            </tr>
            <tr> </tr>

            </tbody>

          </thead>
        </table> 

            <!-- <ul v-if="innerItem.Id == 0" id="v-for-object" class="demo">
              <li
                v-for="note in EUMFootnotes"
                :key="note.InvestmentID"
              >{{ note.TagNumber }} {{"-"}} {{note.Footnote}}</li>
            </ul>
            <ul v-if="innerItem.Id == 1" id="v-for-object" class="demo">
              <li
                v-for="note in EPPFootnotes"
                :key="note.InvestmentID"
              >{{ note.TagNumber }} {{"-"}} {{note.Footnote}}</li>
            </ul>-->
          </div>
        <div v-if="innerItem.Id == 1" class="col">
        <table class="pdf-footnote2">
          <thead>
            <tbody v-for="note in EPPFootnotes" :key="note.InvestmentID">
            <tr >
              <td  style="text-align:left;vertical-align:top;padding:1;">{{"["+ note.TagNumber +"]" }}</td>
             <!-- <tr class="blank_row">
                <td colspan="2"></td>
              </tr> -->
              <td style="text-align:left;vertical-align:top;padding:1;">{{note.Footnote}} <br /></td>
              <td styple="padding:1;"></td>
            </tr>
            <tr> </tr>

            </tbody>

          </thead>
        </table> 
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import _ from "lodash";
import linq from "linq";

import BaseGrid from "@/components/base/BaseGrid.vue";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
import funcUtil from "@/services/funcUtil.js";
import apiUtil from "@/services/apiUtil.js";
import deepGroupBy from "@/services/groupByUtil.js";

import BaseModelPartner from "@/models/BaseModelPartner.js";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseModelInvestment from "@/models/BaseModelInvestment.js";
import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import BaseModelTransactionLog from "@/models/BaseModelTransactionLog.js";
import BaseModelDistribution from "@/models/BaseModelDistribution.js";
import BaseModelAllocation from "@/models/BaseModelAllocation.js";
import BaseModelDirectInvestmentValuation from "@/models/BaseModelDirectInvestmentValuation.js";
import BaseModelFMVStatementFootnote from "@/models/BaseModelFMVStatementFootnote.js";
import BaseModelFootnote from "@/models/BaseModelFootnote.js";
import BaseModelFMVStatementReport from "@/models/BaseModelFMVStatementReport.js";
import BaseMultiSelectDropdown from "@/components/base/BaseMultiSelectDropdown.vue";
import BaseModelVesting from "@/models/BaseModelVesting.js";
import BaseInvestmentValuation from "@/models/BaseModelInvestmentValuation.js"
import { GridConfig, ToolBarConfig } from "./FMVSBulkProcessingConfig.js";
import {fs} from 'fs';
import {
  EUMGridConfig,
  EPPGridConfig,
  FMVStatementToolBarConfig
} from "@/views/fmvs/FMVSReportConfig.js";

import { mapGetters, mapActions, mapState } from "vuex";
import FMVMixin from "@/mixins/FMVMixin.js";
import { setTimeout } from "timers";
import BaseModelMemo from "@/models/BaseModelMemo.js";
import BaseModelUnitRunningTotal from "@/models/BaseModelUnitRunningTotal.js";
import { isNullOrUndefined } from "util";

export default {
  name: "FMVBulkProcessing",
  mixins: [toolbarUtility, apiUtil, funcUtil, FMVMixin],

  components: {
    Breadcrumb,
    BaseGrid,
    BaseToolBar,
    BaseMultiSelectDropdown
  },

  created() {
    this.getInputControls();
  },

  computed: {
    ...mapGetters("getModule", [
      "withFilter",
      "getLocalInputControls",
      "getJoinedItemsFilter"
    ]),
    ...mapState("postModule", ["response"])
  },

  data: function() {
    return {
      BaseModelPartner: BaseModelPartner,
      BaseModelProgram: BaseModelProgram,
      BaseModelInvestment: BaseModelInvestment,
      BaseModelInputControl: BaseModelInputControl,
      BaseModelTransactionLog: BaseModelTransactionLog,
      BaseModelDistribution: BaseModelDistribution,
      BaseModelAllocation: BaseModelAllocation,
      BaseModelDirectInvestmentValuation: BaseModelDirectInvestmentValuation,
      BaseModelFMVStatementFootnote: BaseModelFMVStatementFootnote,
      BaseModelFootnote: BaseModelFootnote,
      FMVStatementToolBarConfig: FMVStatementToolBarConfig,
      BaseModelFMVStatementReport: BaseModelFMVStatementReport,
      BaseModelVesting: BaseModelVesting,
      BaseModelMemo: BaseModelMemo,
      BaseModelUnitRunningTotal: BaseModelUnitRunningTotal,
      BaseInvestmentValuation : BaseInvestmentValuation,

      EUMGridConfig: EUMGridConfig,
      EPPGridConfig: EPPGridConfig,
      GridConfig: GridConfig,
      ToolBarConfig: ToolBarConfig,

      dropdownOptions: {
        ProgramType: {
          model: "",
          dataSource: []
        },
        Partner: {
          model: "",
          dataSource: []
        },
        TaxPeriod: {
          model: "",
          dataSource: []
        },
        PriorTaxPeriod: {
          model: "",
          dataSource: []
        },
        MemoGroup: {
          model: "",
          dataSource: []
        }
      },

      criteriaData: {
        ProgramType: "",
        Partner: [],
        TaxPeriod: "",
        PriorTaxPeriod: "",
        showDropdownPartners: false,
        search: "",
        label: "Select Partner",
        MemoGroup: ""
        // PartnerSelected:""
      },

      priorTaxPeriod: "",
      taxDateToFilter: "",
      priorTaxDateToFilter: "",
      selectedTaxYear: "",
      selectedTaxQuarter: "",

      ProgramandUnit: [],
      Distribution: [],
      PriorDistribution: [],
      Investment: [],
      Vesting: [],
      Valuation: [],
      PriorValuation: [],

      ContributionDistributionValuation: [],
      PriorContributionDistributionValuation: [],
      EPPInvestment: [],
      displayEUM: false,
      EUMProgramTypeGridData: [],
      displayEPP: false,
      EPPProgramTypeGridData: [],

      displayGrid: false,
      FMVBulkGridData: [],
      strFootnotes: "",
      EUMProgramTypeGridPdfData: [],
      EUMFootnotes: [],
      EPPFootnotes: [],
      PartnerList: [],
      investmentSuperScript: [],
      investmentGroupSuperScript: [],
      FMVBulkPDFData: [],
      FMVBulkPDFLoopData: [],
      currentPDFIndex: 0,
      MemoStartingSummary: "",
      MemoEndingSummary: "",
      MemoProgramTextArray: [],
      MemoProgramCurrentValueTextArray: [],
      MemoProgramPotentialValueTextArray: [],
      FMVBulkMemoProgramTextArray: [],
      isVisible: false,
      MemoTaxPeriodData: []
    };
  },

  mounted() {
    const self = this;

    $("body").click(function(e) {
      if (
        $(e.target).closest(".vue-select-container").length == 0 &&
        $(e.target).closest(".vue-dropdown-panel").length == 0
      ) {
        if (self.criteriaData.Partner.length == 0) {
          self.criteriaData.Partner = [];
          self.criteriaData.All = false;
        }
        self.criteriaData.showDropdownPartners = false;
      }
    });

    //bind databound event to grid
    const grid = $("#FMVStatementBulkProcessingGrid").data("kendoGrid");
    grid.bind("dataBound", self.EnableErrorButton);
    // grid.dataSource.fetch();
  },

  methods: {
    ...mapActions("postModule", [
      "UpdateAllItems",
      "UpdateItems",
      "CreateItems"
    ]),

    statementDownload(e) {
      e.preventDefault();
      let gview = window.$("#FMVStatementBulkProcessingGrid").data("kendoGrid");
      let dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));
      if (dataItem.Status == "Completed") {
        if (dataItem.DownloadLink == "") {
          this._AlertPopup("File not found", "info");
        } else {
          this._downloadFile(dataItem.DownloadLink);
        }
      } else {
        this._AlertPopup(
          "Report is not yet generated. Please try again once it is completed!",
          "info"
        );
      }
    },

    EnableErrorButton(e) {
      if (e != null && e != undefined) {
        e.preventDefault();
      }
      let self = this;
      let currentGridData = self.FMVBulkGridData; //JSON.parse(JSON.stringify($("#FMVStatementBulkProcessingGrid").data().kendoGrid.dataSource.data()));
      let ErrorGridData = [];
      ErrorGridData = currentGridData.filter(obj => obj.Status == "Error");

      if (ErrorGridData.length > 0) {
        //Error Record avaialble, display the error report button
        $("#btnGenerateErrorPDF").css("display", "block");
      } else {
        //Error Record not avaialble, should not display the error report button
        $("#btnGenerateErrorPDF").css("display", "none");
      }
    },

    gotoFMVFootnotes: function(e) {
      if (e != null && e != undefined) {
        e.preventDefault();
      }
      this.$router.push("/valuation/fmvs/footnote");
    },

    gotoFMVENTRY: function(e) {
      if (e != null && e != undefined) {
        e.preventDefault();
      }
      this.$router.push("/valuation/fmvs");
    },
    generateErrorPDF: function(e) {
      if (e != null && e != undefined) {
        e.preventDefault();
      }
      let self = this;

      let currentGridData = self.FMVBulkGridData; //JSON.parse(JSON.stringify($("#FMVStatementBulkProcessingGrid").data().kendoGrid.dataSource.data()));
      let SelectedGridData = [];
      SelectedGridData = currentGridData.filter(obj => obj.Status == "Error");

      if (SelectedGridData.length <= 0) {
        this._AlertPopup("No Error records found!", "info");
      } else {
        // SelectedGridData = self.FMVBulkGridData;
        self.currentPDFIndex = 0;
        self.getPDF(".pdf-page1", self.FMVBulkGridData, true);
      }
    },

    generatePDF: function(e) {
      if (e != null && e != undefined) {
        e.preventDefault();
      }
      let self = this;

      let grid = $("#FMVStatementBulkProcessingGrid").data("kendoGrid");
      let SelectedGridData = [];
      grid.select().each(function() {
        let selectedDataItem = JSON.parse(JSON.stringify(grid.dataItem(this)));
        // selectedDataItem.Status = "Approved";
        //push the dataItem into the array
        SelectedGridData.push(selectedDataItem);
      });
      if (SelectedGridData.length <= 0) {
        this._AlertPopup("Please select atleast one item to proceed.", "info");
      } else {
        // SelectedGridData = self.FMVBulkGridData;
        self.currentPDFIndex = 0;
        self.getPDF(".pdf-page1", SelectedGridData);
      }
    },

     getPDF(selector, SelectedGridData, RerunErrors) {
      let self = this;
      //Recursive check
      if (self.currentPDFIndex >= self.FMVBulkPDFLoopData.length) {
        self._AlertPopup("PDF Generation Has Finished!","success");
        return;
      } 

      // let CurrentPartnerId =
      //   self.FMVBulkPDFLoopData[self.currentPDFIndex].PartnerId;

      var CurrentPartnerId;
      if(_.isEmpty(self.FMVBulkPDFLoopData[self.currentPDFIndex])) {
        self.FMVBulkGridData[self.currentPDFIndex].Status = "No Data";
        self.currentPDFIndex = self.currentPDFIndex + 1;
        self.getPDF(selector, SelectedGridData, RerunErrors);

      } else {
               CurrentPartnerId =
        self.FMVBulkPDFLoopData[self.currentPDFIndex].PartnerId;
      }

      let SelectedIndex = SelectedGridData.findIndex(
        p => p.Id == CurrentPartnerId
      );
      if (SelectedIndex >= 0) {
        let GridIndex = self.FMVBulkGridData.findIndex(
          p => p.Id == CurrentPartnerId
        );
        if (RerunErrors == true) {
          //Process the error records
          if (self.FMVBulkGridData[GridIndex].Status == "Error") {
            self.UploadReportandUpdateList(
              selector,
              SelectedGridData,
              RerunErrors,
              GridIndex,
              CurrentPartnerId
            );
          } else {
            //Recursive call to avoid async issue
            self.currentPDFIndex = self.currentPDFIndex + 1;
            self.getPDF(selector, SelectedGridData, RerunErrors);
          }
        } else {
          self.UploadReportandUpdateList(
            selector,
            SelectedGridData,
            RerunErrors,
            GridIndex,
            CurrentPartnerId
          );
        }
      }
    },

    UploadReportandUpdateList(
      selector,
      SelectedGridData,
      RerunErrors,
      GridIndex,
      CurrentPartnerId
      ) {
      let self = this;
      self.FMVBulkPDFData = [];
        console.log("element ", self.FMVBulkPDFLoopData[self.currentPDFIndex]);
        self.FMVBulkPDFData.push(self.FMVBulkPDFLoopData[self.currentPDFIndex]);
      //  console.log($(selector));
      let filteredArray = _.filter(self.FMVBulkMemoProgramTextArray, {
        PartnerId: CurrentPartnerId
      });
      if (filteredArray && filteredArray.length > 0) {
        self.MemoProgramTextArray = filteredArray[0].MemoArray;
      }
      self.MemoProgramCurrentValueTextArray = self.MemoProgramTextArray.filter(
        x => x.Location != "Potential Value"
      );
      self.MemoProgramPotentialValueTextArray = self.MemoProgramTextArray.filter(
        x => x.Location == "Potential Value"
      );

      let currentPartnerFilterQuery = {
        filter: "Id eq " + CurrentPartnerId
      };
      let currentPartnerData = self.withFilter(
        self.BaseModelPartner.list,
        currentPartnerFilterQuery
      );
      var partnerTaxId = "";
      if (currentPartnerData && currentPartnerData[0].TaxId) {
        partnerTaxId = currentPartnerData[0].TaxId;
      } else {
        partnerTaxId = "";
      }
      // DOM is not updated yet
      self.$nextTick(function() {
        self.headerSuperscript();
        // DOM is now updated
        // `this` is bound to the current instance
        self.FMVBulkGridData[GridIndex].Status = "In Progress";
        $("#FMVStatementBulkProcessingGrid")
          .data()
          .kendoGrid.dataSource.data(self.FMVBulkGridData);

        //console.log("kendo",document.getElementsByClassName("pdf-page1")[0]);;

        //console.log($(selector).css());

        $(selector).css("display", "block");
        // $(CurrentSelector.id).css("display", "block")

         kendo.drawing
          .drawDOM($(selector), {
          forcePageBreak: ".page-break",
          multiPage: true,
          allPages: true,
          paperSize: "A4",
          landscape: false,
          repeatHeaders:true,
          scale: 0.7
          })
          .then(function(group) {
            //console.log("group",group);
            // console.log("selector while saving:", this);
            //kendo.drawing.pdf.saveAs(group, "EUMPartner.pdf"); // this is not needed since we don't download PDF directly
            let priorTaxPeriod = !isNullOrUndefined(self.priorTaxPeriod)
              ? "_P" + self.priorTaxPeriod.replace(/\s+/g, "") + "_"
              : "";
            //console.log("prior tax period", priorTaxPeriod);
            // let FileName =
            //   "FMVReport_EUM_EPP_C" +
            //   self.selectedTaxYear +
            //   self.selectedTaxQuarter +
            //   priorTaxPeriod +
            //   CurrentPartnerId +
            //   ".pdf"; // PartnerId
            let date = new Date(self.taxDateToFilter);
            let taxDate =
              date.getMonth() + "" + date.getDate() + "" + date.getFullYear();
            //     const result = this.withFilter(BaseModelPartner.list, "");
            //               this.ProgramInfoTemplate.parent.TaxID =(result.length <= 0) ? 700001 : this._getIncrementalID(result,"ProgramID");
            // let FileName =
            //   partnerTaxId +
            //   "_" +
            //   self.selectedTaxYear +
            //   "_" +
            //   self.selectedTaxQuarter +
            //   "_" +
            //   taxDate +
            //   "_" +
            //   "PVSTMT" +
            //   ".pdf";
            let lengthTaxId = partnerTaxId.toString().split('-').length;
            let FileName = 
              partnerTaxId.toString().split('-')[lengthTaxId-1]+
              "_" +
              self.FMVBulkGridData[GridIndex].FullName +
              "_" +
              self.selectedTaxYear +
              "_" +
              self.selectedTaxQuarter +
              "_" + "FMV Report.pdf";


              //let blob = new Blob([document.getElementsByClassName("pdf-page1")[0].innerHTML], {type: 'text/html'})
              //console.log("blob",blob)
            kendo.drawing.pdf.toBlob(group, function(blob) {
              let fileMetadata = {
                File: FileName,
                FileContent: blob
              };
              self
                ._postFile(
                  {
                    list: "Report" //"Documents"
                  },
                  fileMetadata
                )
                .then(res => {
                  console.log("upload Response : ", res);
                  if (res.status == "success") {
                    //update the status and Download link fields
                    self.FMVBulkGridData[GridIndex].Status = "Completed";
                    // ////////////////////////////////////////////// for testing error records -- need to remove later
                    // if(RerunErrors != true ){
                    //     if(GridIndex % 2 == 0){
                    //         self.FMVBulkGridData[GridIndex].Status = "Error";
                    //     }else{
                    //         self.FMVBulkGridData[GridIndex].Status = "Completed";
                    //     }
                    // }
                    // /////////////////////////////////////////////
                    if (res.data != null && res.data.data != undefined) {
                      if (
                        res.data.data.FileServerRelativeUrl != null &&
                        res.data.data.FileServerRelativeUrl != undefined
                      ) {
                        self.FMVBulkGridData[GridIndex].DownloadLink =
                          process.env.VUE_APP_DownloadUrlBase +
                          res.data.data.FileServerRelativeUrl;
                      }
                    }
                  } else {
                    //update the status to error/ in progress and Download link to empty
                    self.FMVBulkGridData[GridIndex].Status = "Error";
                    self.FMVBulkGridData[GridIndex].DownloadLink = "";
                  }
                  $("#FMVStatementBulkProcessingGrid")
                    .data()
                    .kendoGrid.dataSource.data(self.FMVBulkGridData);
                  //Create or Update the record into the FMVStatementReport List
                  let FMVReportQuery = {
                    filter: "PartnerId eq " + self.FMVBulkGridData[GridIndex].Id
                  }; // + "and TaxYearQuarter eq " + self.criteriaData.TaxPeriod
                  let fmvReportListforPartner = self.withFilter(
                    self.BaseModelFMVStatementReport.list,
                    FMVReportQuery
                  );
                  let PartnerTaxperiodFilterList = [];
                  PartnerTaxperiodFilterList = fmvReportListforPartner.filter(
                    obj =>
                      obj.TaxYear == self.selectedTaxYear &&
                      obj.TaxQuarter == self.selectedTaxQuarter
                  );
                  let CreateorUpdateObject = {
                    Id: "",
                    PartnerId: "",
                    TaxId : "",
                    TaxYear: "",
                    TaxQuarter: "",
                    Status: "",
                    DownloadLink: ""
                  };

                  if (PartnerTaxperiodFilterList.length > 0) {
                    //need to update the record
                    CreateorUpdateObject.Id = PartnerTaxperiodFilterList[0].Id;
                    CreateorUpdateObject.PartnerId =
                      self.FMVBulkGridData[GridIndex].Id;
                    CreateorUpdateObject.TaxId = partnerTaxId;
                    CreateorUpdateObject.TaxYear = self.selectedTaxYear;
                    CreateorUpdateObject.TaxQuarter = self.selectedTaxQuarter;
                    CreateorUpdateObject.Status =
                      self.FMVBulkGridData[GridIndex].Status;
                    CreateorUpdateObject.DownloadLink =
                      `${process.env.VUE_APP_ApiBaseUrl}/Report/filename/${fileMetadata.File}`; 
                    //  self.FMVBulkGridData[GridIndex].DownloadLink;
                    let updateItem = {
                      list: self.BaseModelFMVStatementReport,
                      payload: CreateorUpdateObject
                    };
                    self.UpdateItems(updateItem).then(res => {
                      //   console.log(res);
                    });
                  } else {
                    //need to create a new record
                    CreateorUpdateObject.PartnerId =
                      self.FMVBulkGridData[GridIndex].Id;
                    CreateorUpdateObject.TaxYear = self.selectedTaxYear;
                    CreateorUpdateObject.TaxId = partnerTaxId;
                    CreateorUpdateObject.TaxQuarter = self.selectedTaxQuarter;
                    CreateorUpdateObject.Status =
                      self.FMVBulkGridData[GridIndex].Status;
                    CreateorUpdateObject.DownloadLink =
                       `${process.env.VUE_APP_ApiBaseUrl}/Report/filename/${fileMetadata.File}`; 
                   //   self.FMVBulkGridData[GridIndex].DownloadLink;

                    let createItem = {
                      list: self.BaseModelFMVStatementReport,
                      payload: CreateorUpdateObject
                    };
                    self.CreateItems(createItem).then(res => {
                      // console.log(res);
                    });
                  }
                });
            });

            //self.headerSuperscript();

            $(selector).css("display", "none");
            // $(CurrentSelector.id).css("display", "none")
            // console.log("PDF generated", output);

            //Recursive call to avoid async issue
            self.currentPDFIndex = self.currentPDFIndex + 1;
            self.getPDF(selector, SelectedGridData, RerunErrors);
        //  },0);
          });
      });
    },

    GridToolBarClick(e) {
      const self = this;
      e.preventDefault();
      if (e.id == "btnRefresh") {
        self.refreshGrid();
      } else if (e.id == "btnGeneratePDF") {
        self.generatePDF();
      } else if (e.id == "btnGenerateErrorPDF") {
        self.generateErrorPDF();
      } else if (e.id = "btnDownload") {
          let self = this;
          let selectedRowCount = 0;
          let grid = $("#FMVStatementBulkProcessingGrid").data("kendoGrid");
          let zipFilename = "Documents.zip";
          let urls = [];
          grid.select().each(function() {
            selectedRowCount++;
            urls.push(grid.dataItem(this).DownloadLink);
          });
          if (selectedRowCount > 0) {
            //let blobResponses=[];
            self
              ._ConfirmationPopup(
                `Are You Sure To Download ${selectedRowCount} Files ? This Might Take Some Time!`,
                "default"
              )
              .then(response => {
                if (response.value) {
                  self._downloadFilesZip(urls, zipFilename);
                }
              });
          } else {
            self._AlertPopup("Please select atleast one row", "info");
          }
      }

      self._baseToolBarEvents(self.GridConfig.grid.gridId, ...arguments);
    },

    refreshGrid: function() {
      this.getReportData();
    },

    headerSuperscript() {
      let self = this;

      let EUMresponse = self.withFilter(
        self.BaseModelFMVStatementFootnote.list,
        {
          filter:
            "TaxPeriod eq '" +
            self.criteriaData.TaxPeriod +
            "' and Page eq 'EUM'"
        }
      );

      if (EUMresponse.length) {
        for (var i = 0; i < EUMresponse.length; i++) {
          if (EUMresponse[i].Column != "" && EUMresponse[i].Column != null) {
            if (EUMresponse[i].Column.length) {
              var eumColumnArray = [];
              if (EUMresponse[i].Column.indexOf(",") < 0) {
                eumColumnArray[0] = EUMresponse[i].Column;
              } else {
                eumColumnArray = EUMresponse[i].Column.split(",");
              }

              eumColumnArray.forEach(element => {
                $("table.pdf-table thead tr.EUM th").each(function() {
                  if ($(this).attr("attr") == element) {
                    let chkTitleSuperScript = $(this)[0].innerHTML.indexOf(
                      "<sup>[" + EUMresponse[i].TagNumber + "]</sup>"
                    );
                    if (chkTitleSuperScript < 0) {
                      // $(this).html(
                      //   $(this).text() +
                      //     "<sup>[" +
                      //     EUMresponse[i].TagNumber +
                      //     "]</sup>"
                      // );

                      $(this)[0].innerHTML =
                        $(this)[0].innerHTML +
                        "<sup>[" +
                        EUMresponse[i].TagNumber +
                        "]</sup>";
                    }
                  }
                });
              });
            }
          }
        }
      }

      let EPPresponse = self.withFilter(
        self.BaseModelFMVStatementFootnote.list,
        {
          filter:
            "TaxPeriod eq '" +
            self.criteriaData.TaxPeriod +
            "' and Page eq 'EPP'"
        }
      );

      if (EPPresponse.length) {
        for (var i = 0; i < EPPresponse.length; i++) {
          if (EPPresponse[i].Column != "" && EPPresponse[i].Column != null) {
            if (EPPresponse[i].Column.length) {
              var eppColumnArray = [];
              if (EPPresponse[i].Column.indexOf(",") < 0) {
                eppColumnArray[0] = EPPresponse[i].Column;
              } else {
                eppColumnArray = EPPresponse[i].Column.split(",");
              }

              eppColumnArray.forEach(element => {
                $("table.pdf-table thead tr.EPP th").each(function() {
                  // if ($(this).attr("attr") == element) {
                  //   if (
                  //     $(this)
                  //       .text()
                  //       .indexOf("sup") < 0
                  //   ) {
                  //     $(this).html(
                  //       $(this).text() +
                  //         "<sup>[" +
                  //         EPPresponse[i].TagNumber +
                  //         "]</sup>"
                  //     );
                  //   }
                  // }
                  if ($(this).attr("attr") == element) {
                    let chkTitleSuperScript = $(this)[0].innerHTML.indexOf(
                      "<sup>[" + EPPresponse[i].TagNumber + "]</sup>"
                    );
                    if (chkTitleSuperScript < 0) {
                      // $(this).html(
                      //   $(this).text() +
                      //     "<sup>[" +
                      //     EUMresponse[i].TagNumber +
                      //     "]</sup>"
                      // );

                      $(this)[0].innerHTML =
                        $(this)[0].innerHTML +
                        "<sup>[" +
                        EPPresponse[i].TagNumber +
                        "]</sup>";
                    }
                  }                  
                });
              });
            }
          }
        }
      }
    },

    getInputControls: function() {
      const self = this;
      let response = self.getLocalInputControls(
        self.BaseModelInputControl.list
      );

      self.dropdownOptions["MemoGroup"] = response["MemoGroup"];
      
      self.dropdownOptions["TaxPeriod"] = response["TaxPeriod"].sort((a, b) =>
        a.Option < b.Option ? -1 : 1
      );

      self.PartnerList = []; //self.withFilter(self.BaseModelPartner.list); //,{filter: "ReceiveFMV eq Yes"}
      let resPartner = self.withFilter(self.BaseModelPartner.list);

      var partnerData = [];
      if (resPartner.length) {
        resPartner.forEach(item => {
          if (item.ReceiveFMV == "Yes") {
            self.PartnerList.push(item); // create a list of Partners having ReceiveFMV =="Yes"
            let obj = {};
            obj.Id = item.Id;
            obj.Option = item.FullName;
            partnerData.push(obj);
          }
        });
      }

      self.dropdownOptions["Partner"] = partnerData.sort((a, b) =>
        a.Option < b.Option ? -1 : 1
      );
    },

    onMemoGroupChange: function(e) {
      const self = this;

      self.PartnerList = []; //self.withFilter(self.BaseModelPartner.list); //,{filter: "ReceiveFMV eq Yes"}
      //let memoGroupId = self.criteriaData.MemoGroup;
      let memoGroupId = e.dataItem.Option;

      //let resPartner = self.withFilter(self.BaseModelPartner.list, { filter: "MemoGroup eq " + memoGroupId });
      let resPartner = self.withFilter(self.BaseModelPartner.list);

        var partnerData = [];
        if (resPartner.length) {
          if (memoGroupId != '')
          {
            resPartner.forEach(item => {
              if (item.MemoGroup == memoGroupId) {
                self.PartnerList.push(item); // create a list of Partners having ReceiveFMV =="Yes"
                let obj = {};
                obj.Id = item.Id;
                obj.Option = item.FullName;
                partnerData.push(obj);
              }
            });
          }
          else
          {
            resPartner.forEach(item => {
                self.PartnerList.push(item); // create a list of Partners having ReceiveFMV =="Yes"
                let obj = {};
                obj.Id = item.Id;
                obj.Option = item.FullName;
                partnerData.push(obj);
              }
            );
          }
        }

        self.dropdownOptions["Partner"] = partnerData.sort((a, b) =>
          a.Option < b.Option ? -1 : 1
        );
    },

    onTaxPeriodChange: function(e) {
      const self = this;
      let priorTaxPeriod = self.dropdownOptions["TaxPeriod"];

      let i = priorTaxPeriod.findIndex(item => {
        return item["Option"] === e.dataItem.Option;
      });

      let filteredPriorTaxPeriod = priorTaxPeriod.slice(0, i);
      self.dropdownOptions["PriorTaxPeriod"] = filteredPriorTaxPeriod.sort(
        (a, b) => {
          a.Option < b.Option ? -1 : 1;
        }
      );
    },
    
    getTaxandPriorTaxPeriod: function(taxYear, taxQuarter) {
      if (taxQuarter == "Q1") {
        return taxYear + "/3/31";
      } else if (taxQuarter == "Q2") {
        return taxYear + "/6/30";
      } else if (taxQuarter == "Q3") {
        return taxYear + "/9/30";
      } else {
        return taxYear + "/12/31";
      }
    },

    getReportData: function(e) {
      e.preventDefault();
      const self = this;
      self.ProgramandUnit = [];
      self.Distribution = [];
      self.PriorDistribution = [];
      self.Investment = [];
      self.Vesting = [];
      self.Valuation = [];
      self.PriorValuation = [];

      self.ContributionDistributionValuation = [];
      self.PriorContributionDistributionValuation = [];
      self.EPPInvestment = [];

      self.displayGrid = false;
      self.FMVBulkGridData = [];
      //Empty Memo Data
      (self.MemoStartingSummary = ""),
        (self.MemoEndingSummary = ""),
        (self.MemoProgramTextArray = []),
        (self.MemoProgramCurrentValueTextArray = []),
        (self.MemoProgramPotentialValueTextArray = []);
      (self.FMVBulkMemoProgramTextArray = []), (self.MemoTaxPeriodData = []);

      // Find the PriorTaxPeriod, TaxDate and PriorTaxDate to filter the data.
      if (self.criteriaData.TaxPeriod.length) {
        //Get Dynamic Memo Text
        let memoFilter = {
          filter: "TaxPeriod eq '" + self.criteriaData.TaxPeriod + "'"
        };
        let MemoDataByTaxPeriod = this.withFilter(
          BaseModelMemo.list,
          memoFilter
        );
        self.MemoTaxPeriodData = MemoDataByTaxPeriod;
        if (MemoDataByTaxPeriod && self.criteriaData.Partner.length > 0) {
          let startSummary = _.filter(MemoDataByTaxPeriod, function(item) {
            return item.MemoType == "Starting Summary";
          });
          self.MemoStartingSummary =
            startSummary && startSummary[0] ? startSummary[0].MemoText : "";

          let endSummary = _.filter(MemoDataByTaxPeriod, function(item) {
            return item.MemoType == "Ending Summary";
          });

          self.MemoEndingSummary =
            endSummary && endSummary[0] ? endSummary[0].MemoText : "";
        }
        let selectedTaxPeriod = _.split(
          self.criteriaData.TaxPeriod.toString(),
          " "
        );

        let selectedPriorTaxPeriod = _.split(
          self.criteriaData.PriorTaxPeriod.toString(),
          " "
        );

        self.taxDateToFilter = self.getTaxandPriorTaxPeriod(
          selectedTaxPeriod[0],
          selectedTaxPeriod[1]
        );

        self.priorTaxPeriod = self.criteriaData.PriorTaxPeriod;

        self.priorTaxDateToFilter = self.getTaxandPriorTaxPeriod(
          selectedPriorTaxPeriod[0],
          selectedPriorTaxPeriod[1]
        );

        console.log(self.criteriaData, "FilterData");
        console.log(self.taxDateToFilter, "taxdate");
        console.log(self.priorTaxPeriod, "Prior Tax Period");
        console.log(self.priorTaxDateToFilter, "Prior Tax date");

        self.selectedTaxYear = selectedTaxPeriod[0];
        self.selectedTaxQuarter = selectedTaxPeriod[1];
      }

      // let multiSelect = $("#PartnerMultiSelect").data("kendoMultiSelect");
      let SelectedPartnerCount = self.criteriaData.Partner.length;
      // alert(SelectedPartnerCount);

      if (self.criteriaData.TaxPeriod.length > 0 && SelectedPartnerCount > 0) {
        
        self.formBulkGridData();
      } else {
        self._AlertPopup(
          "Please select Partner and Tax Period to proceed!",
          "warning"
        );
      }
    },

    formBulkGridData: function() {
      const self = this;
      self._APICrudPopup("APICrudpopup");
      self.FMVBulkGridData = [];
      self.FMVBulkPDFData = [];
      self.FMVBulkPDFLoopData = [];
      self.displayGrid = true;
      let SelectedPartnersArray = [];
      self.criteriaData.Partner.forEach(element => {
        SelectedPartnersArray.push(element.Id);
      });
      
      let SelectedPartnerDetails = self.PartnerList.filter(
        obj => SelectedPartnersArray.indexOf(obj.Id) >= 0
      );


      setTimeout(() => {

      SelectedPartnerDetails.forEach(PartnerItem => {
        let GridItem = {
          Id: "",
          PartnerID: "",
          FullName: "",
          Status: "",
          DownloadLink: ""
        };
        GridItem.Id = PartnerItem.Id;
        GridItem.PartnerID = PartnerItem.PartnerID;
        GridItem.FullName = PartnerItem.FullName;
        GridItem.Status = "Not Started"; // "In Progress" "Completed"
        GridItem.DownloadLink = "";
        self.FMVBulkGridData.push(GridItem);
      });
      console.log("FMVBulkGridData ", self.FMVBulkGridData);

      //need to loop thru each partner and get the report data
      //self.currentPDFIndex = 0;
      //let loader = this.$loading.show();
      
      
      self.FMVBulkGridData.forEach(element => {
        self.ProgramandUnit = [];
        self.Distribution = [];
        self.PriorDistribution = [];
        self.Investment = [];
        self.Vesting = [];
        self.Valuation = [];
        self.PriorValuation = [];

        self.ContributionDistributionValuation = [];
        self.PriorContributionDistributionValuation = [];
        self.EPPInvestment = [];

        // self.criteriaData.Partner={};
        // element.Status = "In Progress";
        self.criteriaData.Partner.Id = element.Id;
        // self.criteriaData.Partner.text = element.FullName;



        //EUM Report
        self.formEUMGridData();
        var investmentAPIData = self.withFilter(self.BaseModelInvestment.list);
        if (
          self.EUMProgramTypeGridPdfData &&
          self.EUMProgramTypeGridPdfData.length > 0
        ) {
          console.log("Before PDF data",self.EUMProgramTypeGridPdfData);
            self.EUMProgramTypeGridPdfData.forEach(function(obj){
                console.log("obj",obj.InvestmentGroup === undefined);
                if(obj.InvestmentGroup === undefined) {
                    console.log("obj",obj);
                    let result1 = investmentAPIData.filter(function (res) {
                        return (
                            res.InvestmentID == obj.InvestmentID
                        );
                    })[0];
                    console.log("result1",result1)
                    if(result1) 
                    {
                        obj.InvestmentGroup = result1.InvestmentGroup;
                    }
                }
            })

        }
        self.getFootNotes("EUM");

        //EPP Report //Uncomment this for EPP Data
        self.formEPPGridData();

        if (
          self.EPPProgramTypeGridPdfData &&
          self.EPPProgramTypeGridPdfData.length > 0
        ) {
          console.log("Before PDF data",self.EPPProgramTypeGridPdfData);
            self.EPPProgramTypeGridPdfData.forEach(function(obj){
                //console.log("obj",obj);
                if(obj.InvestmentGroup === undefined) {
                    console.log("obj",obj);
                    let result1 = investmentAPIData.filter(function (res) {
                        return (
                            res.InvestmentID == obj.InvestmentID
                        );
                    })[0];
                    console.log("result1",result1)
                    if(result1) 
                    {
                        obj.InvestmentGroup = result1.InvestmentGroup;
                    }
                }
            })

        }

        self.getFootNotes("EPP");

        let PartnerPDF_EUM_EPP_Data = [];
        if (
          self.EUMProgramTypeGridPdfData &&
          self.EUMProgramTypeGridPdfData.length > 0
        ) {

          PartnerPDF_EUM_EPP_Data.push({
            Id: 0,
            EUMProgramTypeGridPdfData: self.EUMProgramTypeGridPdfData
          });
        }
        if (
          self.EPPProgramTypeGridPdfData &&
          self.EPPProgramTypeGridPdfData.length > 0
        ) {
          //Uncomment this for EPP Data
          PartnerPDF_EUM_EPP_Data.push({
            Id: 1,
            EPPProgramTypeGridPdfData: self.EPPProgramTypeGridPdfData
          });
        }
        // self.getPDF(".pdf-page1",ProgramTypeGridPdfData);
        let pdfitem = {};
        if (PartnerPDF_EUM_EPP_Data.length > 0) {
          pdfitem = {
            PartnerId: element.Id,
            PartnerName: element.FullName,
            PartnerPDF_EUM_EPP_Data: PartnerPDF_EUM_EPP_Data
          };
        }

        // self.FMVBulkPDFData.push(pdfitem);
        self.FMVBulkPDFLoopData.push(pdfitem);

        //FMVBulkMemoProgramTextArray self.criteriaData.Partner.Id = element.Id;
        let AssociatedPrograms = self.getAssociatedPrograms(element.Id);
        let AsscoiatedInvestment = self.getAssociatedInvestment(
          AssociatedPrograms
        );
        let ProgramInvestmentText = self.getProgramInvestmentText(
          self.MemoTaxPeriodData,
          AssociatedPrograms,
          AsscoiatedInvestment
        );
        self.FMVBulkMemoProgramTextArray.push({
          PartnerId: element.Id,
          MemoArray: ProgramInvestmentText
        });
        
      });
      //loader.hide();
      self._AlertPopup("Data Generation Has Finished!","success");
           console.log("PDF data", self.FMVBulkPDFLoopData);
      //localStorage.setItem('pdfData', JSON.stringify(self.FMVBulkPDFLoopData));
      //self.FMVBulkPDFLoopData = [];
      }
      , 1000 * self.FMVBulkGridData.length);

      
      //self.getFootNotes("EUM");

      //Uncomment this for EPP Data
      //self.getFootNotes("EPP");


      
      //self._AlertPopup("Program allocated successfully", "success");
      //console.log(localStorage.getItem('pdfData'));
      
      // console.log("PDF data", self.FMVBulkPDFData);
      // self.$forceUpdate(); 
      //     //  self.getPDF(".pdf-page1");
      //     $("#generatePDF").click();
      // self.currentPDFIndex = 0;
      // self.getPDF(".pdf-page1", self.FMVBulkGridData);      
    },

    // Bulk Process 
    generateBulkPDF : async function(e) {
       e.preventDefault();
       const self = this;
       self.currentPDFIndex = 0;
      //  self.FMVBulkPDFLoopData = [];
      //  self.FMVBulkPDFLoopData = JSON.parse(localStorage.getItem('pdfData'));
       //console.log(typeof(self.FMVBulkPDFLoopData));
       let loader = this.$loading.show();
       self.getPDF(".pdf-page1", self.FMVBulkGridData);
       //let r = await self.getPDF(".pdf-page1", self.FMVBulkGridData);
       loader.hide();
       
    },

    getFootNotes(EumOREpp) {
      const self = this;
      if (EumOREpp == "EUM") {
        self.EUMFootnotes = [];
      } else if (EumOREpp == "EPP") {
        self.EPPFootnotes = [];
      }

      let footnoteQuery = {
        filter:
          "TaxPeriod eq '" +
          self.criteriaData.TaxPeriod +
          "' and Page eq '" +
          EumOREpp +
          "'"
      };

      let response = self.withFilter(
        self.BaseModelFMVStatementFootnote.list,
        footnoteQuery
      );

      var gridDataForInvestmentAndGroup;
      if (EumOREpp == "EUM") {
        gridDataForInvestmentAndGroup = self.EUMProgramTypeGridData;
        self.investmentSuperScript = [];
        self.investmentGroupSuperScript = [];
      } else if (EumOREpp == "EPP") {
        gridDataForInvestmentAndGroup = self.EPPProgramTypeGridData;
        self.investmentSuperScript = [];
        self.investmentGroupSuperScript = [];
      }

      if (response.length) {

        // Sort by number and alphabets
        const compare = (a,b) => {

          // check for numberhood
          const numA = !isNaN(a.TagNumber);
          const numB = !isNaN(b.TagNumber);
          if(numA && numB){
          	return Number(a.TagNumber) - Number(b.TagNumber);
          }
          if(numA) return -1;
          if(numB) return 1;
          // check for wordhood
          const wordA = /^[a-zA-Z]+$/.test(a.TagNumber);
          const wordB = /^[a-zA-Z]+$/.test(b.TagNumber);
          if(wordA && wordB){
           	return a.TagNumber.localeCompare(b.TagNumber);
          }
          if(wordA || wordB) return (wordA && -1) || 1;

          return 1; //or whatever logic to sort within non-alphanumeric values

        }
        response = response.sort(compare);

        for (var i = 0; i < response.length; i++) {
          let resData = {};
          resData.TagNumber = response[i].TagNumber;
          resData.Footnote = self.getFootNoteText(response[i].FootnoteId);
          if (
            response[i].TagLocation === "Investment" &&
            response[i].Investments != null &&
            response[i].Investments != ""
          ) {
            if (response[i].Investments.length) {
              var investmentArray = [];
              if (response[i].Investments.indexOf(",") < 0) {
                investmentArray[0] = response[i].Investments;
              } else {
                investmentArray = response[i].Investments.split(",");
              }

              investmentArray.forEach(element => {
                var filterObj = gridDataForInvestmentAndGroup.filter(obj => {
                  let suppElement = " (Supplemental Units)";
                  return (
                    // obj.Investment.indexOf(element) >= 0
                    element === ( obj.Investment.toString().split(suppElement)) || 
                    element === (obj.Investment.toString().split("<sup>"))[0] || 
                      obj.Investment.toUpperCase().trimEnd().toString() === element

                    // obj.Investment === element ||
                    // (obj.Investment.toString().substring(0, element.length) ===
                    //   element &&
                    //   obj.Investment.toString()
                    //     .substring(element.length + 1)
                    //     .indexOf("Supplemental Units") > 0) ||
                    // (obj.Investment.toString().substring(0, element.length) ===
                    //   element &&
                    //   obj.Investment.toString()
                    //     .substring(element.length - 1)
                    //     .indexOf("<sup>[") > 0)
                  );
                });
                if (filterObj.length) {
                  filterObj.forEach(item => {
                    item.Investment +=
                      "<sup>[" + response[i].TagNumber + "]</sup>";
                  });
                }
              });
            }
          } else if (
            response[i].InvestmentGroup != "" &&
            response[i].InvestmentGroup != null
          ) {
            if (response[i].InvestmentGroup.length) {
              let htmlDict = {};

              for (let j = 0; j < response.length; j++) {
                if (response[j].TagLocation === "Investment Group") {

                  let investmentGrp = response[j].InvestmentGroup.split(",")
                  if(investmentGrp && investmentGrp.length) {
                    for(let x = 0; x < investmentGrp.length; x++) {
                        if (htmlDict.hasOwnProperty(investmentGrp[x])) {
                            htmlDict[investmentGrp[x]] +=
                              "<sup>[" + response[j].TagNumber + "]</sup>";
                            }                        
                         else {
                            htmlDict[investmentGrp[x]] =
                             investmentGrp[x] +
                              "<sup>[" +
                              response[j].TagNumber +
                              "]</sup>";
                            }
                        }                      
                  }

                  // if (response[j].InvestmentGroup in htmlDict) {

                  // } else {
                  //   let investmentGrp = response[j].InvestmentGroup.split(",")
                  //   if(investmentGrp && investmentGrp.length) {
                  //     for(let x = 0; x < investmentGrp.length; x++) 
                  //     {
                  //       if(!htmlDict.hasOwnProperty(investmentGrp[x])) {
                  //       htmlDict[investmentGrp[x]] =
                  //        investmentGrp[x] +
                  //         "<sup>[" +
                  //         response[j].TagNumber +
                  //         "]</sup>";
                  //       }

                  //     }
                  //   }

                  // }
                }
              }

              var investmentGroupArray = [];
              if (response[i].InvestmentGroup.indexOf(",") < 0) {
                investmentGroupArray[0] = response[i].InvestmentGroup;
              } else {
                investmentGroupArray = response[i].InvestmentGroup.split(",");
              }
              console.log("iinvestmentGroupArray",investmentGroupArray,gridDataForInvestmentAndGroup,htmlDict);

              investmentGroupArray.forEach(element => {
                var filterObj = gridDataForInvestmentAndGroup.filter(
                  h => h.InvestmentGroup == element
                );
                if (filterObj.length) {
                  console.log("filterObj",filterObj,filterObj[0].InvestmentGroup,htmlDict[filterObj[0].InvestmentGroup]);

                  filterObj[0].InvestmentGroup =
                    htmlDict[filterObj[0].InvestmentGroup];
                  

                  console.log("Sup: " + filterObj[0].InvestmentGroup);
                }
              });
            }
          }

          if (EumOREpp == "EUM") {
            self.EUMFootnotes.push(resData);
          } else if (EumOREpp == "EPP") {
            self.EPPFootnotes.push(resData);
          }
        }

        /** sort by numbers,alphabets then special characters for footnotes  */
        if (EumOREpp == "EUM") {
          if (self.EUMFootnotes.length > 0) {
            let exp = /[!@#$%^&*_+\=\[\]{};':"\\|<>\/?]+/;

            let footnotesspecialcharacterlist = [];
            footnotesspecialcharacterlist = self.EUMFootnotes.filter(x =>
              exp.test(x.TagNumber[0])
            );
            if (footnotesspecialcharacterlist.length > 0) {
              self.EUMFootnotes = self.EUMFootnotes.filter(
                x => !exp.test(x.TagNumber[0])
              );
            }
            self.EUMFootnotes = self.EUMFootnotes;
            console.log("EUMFootnotes",self.EUMFootnotes);
            if (footnotesspecialcharacterlist.length > 0) {
              self.EUMFootnotes = self.EUMFootnotes.concat(
                footnotesspecialcharacterlist
              );
            }
          }
        } else if (EumOREpp == "EPP") {
          /** sort by numbers,alphabets then special characters for footnotes  */
          if (self.EPPFootnotes.length > 0) {
            let exp = /[!@#$%^&*_+\=\[\]{};':"\\|<>\/?]+/;

            let footnotesspecialcharacterlist = [];
            footnotesspecialcharacterlist = self.EPPFootnotes.filter(x =>
              exp.test(x.TagNumber[0])
            );
            if (footnotesspecialcharacterlist.length > 0) {
              self.EPPFootnotes = self.EPPFootnotes.filter(
                x => !exp.test(x.TagNumber[0])
              );
            }
            self.EPPFootnotes = self.EPPFootnotes;
            console.log("EPPFootnotes",self.EPPFootnotes);
            if (footnotesspecialcharacterlist.length > 0) {
              self.EPPFootnotes = self.EPPFootnotes.concat(
                footnotesspecialcharacterlist
              );
            }
          }
        }
      }
    },




  }
};
</script>

<style>
#btnExportPdf span {
  font-size: 25px;
}

.vue-select-container {
  display: flex;
  background: #f0f0f0 !important;
  color: #4a4a4a;
  border: 0;
  border-radius: 0;
  outline: 0 !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  padding: 8px 16px;
  height: 40px !important;
}

.ng-value-container {
  padding: 0 16px 0 0;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.vue-placeholder {
  position: relative;
  top: auto;
  padding: 0;
  color: #999;
}

.vue-input {
  top: 0;
  height: 100%;
  padding: 0;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  z-index: 2;
  opacity: 1;
}

.vue-input input {
  color: #999;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  margin: 0;
  background: none;
  border: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
  outline: 0;
  cursor: default;
}

.vue-dropdown-panel {
  border: 1px solid silver;
  line-height: 35px;
  bottom: auto;
  width: 98%;
  opacity: 1;
  position: absolute;
  z-index: 1050;
  background: #fff;
}

.vue-dropdown-header {
  line-height: 35px;
  padding: 0;
}

.vue-dropdown-panel-items {
  padding: 0 16px;
  overflow: hidden;
  overflow-y: auto;
  position: relative;
  height: auto;
  box-sizing: border-box;
  max-height: 240px;
}

.k-checkbox-label:before {
  background-color: #fff !important;
}

.ey-select-all {
  border-bottom: 1px solid #f0f0f0;
  padding: 0px 16px;
}

.vue-dropdown-footer {
  border-top: 1px solid #f0f0f0;
  height: 72px;
  padding: 0;
}

.reverse {
  top: auto;
  bottom: 100%;
}

.FMVImgcentre {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 40%;
}

.FMVbottomdoubleborder {
  border-bottom: 4px double #333;
}

.FMVParabold {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
  font-family: Arial, serif;
  font-size: 14px;
  color: rgb(0, 0, 0);
  font-weight: bold;
  text-align: center;
}

.FMVParatext {
  font-family: Arial, serif;
  font-size: 14px;
  color: rgb(0, 0, 0);
  font-weight: normal;
  font-style: normal;
  text-decoration: none;
}

.FMVcolSpan {
  width: 100px;
  display: inline-block;
}
.total-class td {
  border-bottom: 1px solid;
  padding-top: 2%;
}
.border_right {
  border-right: 1px solid !important;
}
.text_center {
  text-align: center !important;
}
.text_left {
  text-align: left !important;
}
.fullborder {
  border-top: 1px solid !important;
  border-right: 1px solid !important;
  border-left: 1px solid !important;
  border-bottom:none !important;
}

.pdf-footnote  {
  font-size: 10px;
  padding-left: 1.5em;
  text-indent:-2em;
}

th.th-top-EPP-EPP {
  border-top: 1px solid !important;
  border-bottom: 1px solid !important;
}

table thead tr.EUM > th {
  text-align: center;
}
table thead tr.EPP > th {
  text-align: center;
}
table#pdf-template > thead tr:nth-child(1) > td,
table#pdf-template > thead tr:nth-child(2) > td {
  text-align: center;
}
table tbody tr > td {
  text-align: right;
}

.pdf-page1 .new-page {
  font-family: "DejaVu Sans", "Arial", sans-serif;
}
</style>
